var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/external_login/components/external-login-form.tsx";
import React, { useState, useEffect } from 'react';
import { useIntl, FormattedMessage, defineMessages } from 'react-intl';
import { externalLogin, loginWithCode } from 'soapbox/actions/external_auth';
import snackbar from 'soapbox/actions/snackbar';
import { Button, Form, FormActions, FormGroup, Input, Spinner } from 'soapbox/components/ui';
import { useAppDispatch } from 'soapbox/hooks';
const messages = defineMessages({
  instanceLabel: {
    "id": "login.fields.instance_label",
    "defaultMessage": "Instance"
  },
  instancePlaceholder: {
    "id": "login.fields.instance_placeholder",
    "defaultMessage": "example.com"
  },
  instanceFailed: {
    "id": "login_external.errors.instance_fail",
    "defaultMessage": "The instance returned an error."
  },
  networkFailed: {
    "id": "login_external.errors.network_fail",
    "defaultMessage": "Connection failed. Is a browser extension blocking it?"
  }
});

/** Form for logging into a remote instance */
const ExternalLoginForm = () => {
  const code = new URLSearchParams(window.location.search).get('code');
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const [host, setHost] = useState('');
  const [isLoading, setLoading] = useState(false);
  const handleHostChange = ({
    currentTarget
  }) => {
    setHost(currentTarget.value);
  };
  const handleSubmit = () => {
    setLoading(true);
    dispatch(externalLogin(host)).then(() => setLoading(false)).catch(error => {
      console.error(error);
      const status = error.response?.status;
      if (status) {
        dispatch(snackbar.error(intl.formatMessage(messages.instanceFailed)));
      } else if (!status && error.code === 'ERR_NETWORK') {
        dispatch(snackbar.error(intl.formatMessage(messages.networkFailed)));
      }
      setLoading(false);
    });
  };
  useEffect(() => {
    if (code) {
      dispatch(loginWithCode(code));
    }
  }, [code]);
  if (code) {
    return /*#__PURE__*/React.createElement(Spinner, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    "data-testid": "external-login",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    labelText: intl.formatMessage(messages.instanceLabel),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": intl.formatMessage(messages.instancePlaceholder),
    placeholder: intl.formatMessage(messages.instancePlaceholder),
    type: "text",
    name: "host",
    onChange: handleHostChange,
    autoCorrect: "off",
    autoCapitalize: "off",
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(FormActions, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    type: "submit",
    disabled: isLoading,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "login.log_in",
    defaultMessage: "Log in",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 11
    }
  }))));
};
export default ExternalLoginForm;